import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import type { Theme } from 'app/shopify';

export interface ActivitySectorTagProps {
  backgroundColor?: keyof Theme['colors'];
  label: string;
}

export function ActivitySectorTag({ backgroundColor = 'surface.default', label }: ActivitySectorTagProps) {
  return (
    <Row
      alignItems="center"
      justifyContent="center"
      paddingVertical="spacing.general.x1"
      paddingHorizontal="spacing.general.x2"
      borderRadius="radius.sm"
      backgroundColor={backgroundColor}
    >
      <Text variant="bodySmallMedium">{label}</Text>
    </Row>
  );
}
